// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioGroup__root--2Y1R2"};